import type { DndProviderProps } from "react-dnd";

type DndBackendFactory = Extract<
  DndProviderProps<unknown, unknown>,
  { backend: unknown }
>["backend"];

const unsubscribe = () => {};

// The no-op preview list satisfies react-dnd-multi-backend's Preview hook which
// calls previewsList().register() / previewsList().unregister() on the backend.
const noopPreviewList = {
  register: (_listener: unknown) => {},
  unregister: (_listener: unknown) => {},
  backendChanged: (_backend: unknown) => {},
};

const noopDndBackend: DndBackendFactory = (_manager) =>
  // Cast to any to attach the dnd-multi-backend-specific methods below.
  // These are not part of the core Backend interface but are called by
  // react-dnd-multi-backend's Preview component when it accesses the
  // backend via DnD context.  If the global react-dnd singleton is
  // accidentally initialised with this backend (see withDndProvider.js),
  // having these stubs prevents a "previewEnabled is not a function" crash.
  ({
    setup() {},
    teardown() {},
    connectDragSource: () => unsubscribe,
    connectDragPreview: () => unsubscribe,
    connectDropTarget: () => unsubscribe,
    profile: () => ({}),
    // dnd-multi-backend extensions
    previewEnabled: () => false,
    previewsList: () => noopPreviewList,
    backendsList: () => [],
  }) as ReturnType<DndBackendFactory>;

export default noopDndBackend;
